import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { RemoveQuotesPipe } from './remove-quotes.pipe';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { IndexComponent } from './index/index.component';
import { SkilldevelopmentComponent } from './skilldevelopment/skilldevelopment.component';
import { WebinarsComponent } from './webinars/webinars.component';
import { VouchersComponent } from './vouchers/vouchers.component';
import { GiftvouchersComponent } from './giftvouchers/giftvouchers.component';
import { FooterComponent } from './footer/footer.component';
import { SpecialsComponent } from './specials/specials.component';
import { MotherspageComponent } from './motherspage/motherspage.component';
import { EventspageComponent } from './eventspage/eventspage.component';
import { EventsComponent } from './events/events.component';
import { DiwaliVoucherComponent } from './diwali-voucher/diwali-voucher.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    IndexComponent,
    SkilldevelopmentComponent,
    WebinarsComponent,
    VouchersComponent,
    GiftvouchersComponent,
    FooterComponent,
    RemoveQuotesPipe,
    SpecialsComponent,
    MotherspageComponent,
    EventspageComponent,
    EventsComponent,
    DiwaliVoucherComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
